import React from "react";
import ReactDOM from "react-dom/client";
import { HashRouter as Router } from "react-router-dom";
import App from "./App";
import { ConfigService } from "./services/ConfigService";
import { StoreProvider } from "./store";

const setGlobals = () => {
  global.React ||= React;
  global.isAppLoaded ??= false;
  global.isDevelopment ??= process.env.NODE_ENV !== "production";
  global.appEnableStoreLog ??= process.env.REACT_APP_ENABLE_STORE_LOG === "true";
  global.appEnv ??= process.env.REACT_APP_ENV || "local";
  global.appServerUrl ??= process.env.REACT_APP_SERVER_URL || "http://localhost:8000";
};

const renderIntoDOM = async () => {
  if (!global.isAppLoaded) {
    const root = ReactDOM.createRoot(
      document.getElementById("experimentation_admin_container") as HTMLElement
    );
    root.render(
      <StoreProvider>
        <Router>
          <App />
        </Router>
      </StoreProvider>
    );
  }
};

(async () => {
  setGlobals();
  const apiService = new ConfigService();
  const { data: uiConfig = {} }: any = await apiService.getAll({});
  global.appConfig = uiConfig;

  await renderIntoDOM();
})();
